import { createSelector } from '../lib/createSelector';
import { activeCompany } from './userSelectors';

export const embeddedIntegrations = (state) => state.embedded.integrations;

// The embedded MCP route accepts only boolean true, so the dashboard reads the
// company switch with the same rule.
export const embeddedMcpServerEnabled = (state) => activeCompany(state)?.settings?.enableEmbeddedMcp === true;

export const embeddedHasFetchedMetadata = (state) => state.embedded.hasFetchedMetadata;

export const embeddedIntegrationById = createSelector('embeddedIntegrationById', [embeddedIntegrations, (_, integrationId) => integrationId], (embeddedIntegrations, integrationId) => {
  return embeddedIntegrations?.find((n) => n?.id === integrationId);
});

export const integrationWorkflowsByIntegrationId = createSelector('integrationWorkflowsByIntegrationId', [embeddedIntegrationById], (integration) => {
  return integration?.workflows || [];
});

export const integrationAppsByIntegrationId = createSelector('integrationAppsByIntegrationId', [embeddedIntegrationById], (integration) => {
  return integration?.apps || [];
});

export const integrationNameById = createSelector('integrationNameById', [embeddedIntegrationById], (integration) => {
  return integration?.name || '';
});

export const provisionedCredential = (state) => state.embedded.provisionedCredential;
export const credentialExchangeCustomAuthFields = (state) => state.embedded.credentialExchangeCustomAuthFields;
